import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    right: 4,
    top: 0,
    padding: 2,
    backgroundColor: 'rgba(0, 0,0,0.5)',
  },
  text: {
    fontSize: 14,
    lineHeight: 16,
    textAlignVertical: 'center',
    height: 20,
    padding: 0,
    color: 'white',
  },
});
